import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const name = "selectedPrice";
const initialState = {
  selectedPrice: [],
  loading: false,
  error: null,
};

export const selectPrice = createAsyncThunk("price/selected", async (price) => {
  return price;
});

const selectedPriceSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(selectPrice.pending, (state) => {
      state.selectedPrice = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(selectPrice.fulfilled, (state, action) => {
      state.selectedPrice = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(selectPrice.rejected, (state, action) => {
      state.selectedPrice = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default selectedPriceSlice.reducer;
